

















































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

// The available types of modals
import { ModalType } from '@/components/modal/types';

@Component
export default class InteractiveModalContent extends Vue {

    @Prop({
        type: String,
        validator(type: ModalType): boolean {

            return Object.values(ModalType).includes(type);

        },
    })
    private type!: ModalType;

    @Prop({ type: String })
    private title!: string;

    @Prop({ type: String })
    private body!: string;

    /**
     *  Used to get the class for the forwarded type, used
     *  for giving the icon and title the correct color.
     */
    private get typeClass(): string | null {

        return this.type ? `ccos-modal__interactive-content--${ this.type }` : null;

    }

    /**
     *
     *  Used to determine if the warning icon should be used.
     *
     *  (i) The info icon is shown otherwise
     *
     */
    private get warningIcon(): boolean {

        return this.type === ModalType.Warning || this.type === ModalType.Error;

    }

}

